<div class="row">
    <otb-inner-breadcrumb
        *otbShowInEnv="['default', 'justice', 'finance', 'sh', 'hmdj', 'bb-jm']"
    ></otb-inner-breadcrumb>
    <otb-progress-bar></otb-progress-bar>
</div>

<div class="row">
    <h2
        class="col-12"
        [innerHTML]="'dynamische_frontend_texte.anzahl_teilnehmer.html_content.ueberschrift' | translate | safeStyle"
    ></h2>
</div>

<form #mainForm (ngSubmit)="next()" novalidate>
    <div class="row">
        <div class="col-sm-5">
            <h2>
                <small
                    [innerHTML]="
                        'dynamische_frontend_texte.anzahl_teilnehmer.html_content.hinweis_ueberschrift'
                            | translate
                            | safeStyle
                    "
                ></small>
            </h2>
            <p class="autoext-note">{{ aeSignal().note }}</p>
        </div>
        <div class="col-sm-7 mb-3">
            <otb-form-builder-select-numeric
                label="{{ aeSignal().label! | required }}"
                name="participantsCount"
                [items]="options"
                [formControl]="participantsControl"
                [clearable]="false"
                helpText="Bitte geben Sie an, mit wie vielen Personen Sie zum Termin erscheinen"
            >
            </otb-form-builder-select-numeric>
            <otb-form-error-message
                id="participantsCount-error"
                [show]="participantsControl.invalid && participantsControl.touched"
            ></otb-form-error-message>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="form-group d-flex justify-content-between flex-md-row flex-column mt-4 gap-2">
                <otb-back-button></otb-back-button>

                <button
                    type="submit"
                    class="btn-success btn order-md-2 order-1 m-0 mb-3 mb-sm-0"
                    accesskey="w"
                    btnPrimaryColorDirective
                    [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                ></button>
            </div>
        </div>
    </div>
</form>
